import React from 'react'

export const AdmTipos = () => {
  return (
    <div>AdmTipos</div>
  )
}

export default AdmTipos;